import { useEffect, useState } from "react";
import { fetchPage } from "../lib/api";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import PageSections from "../components/PageSections";

export default function LegalPage({ slug, defaultTitle, defaultSubtitle }) {
  const [page, setPage] = useState(null);
  useEffect(() => { fetchPage(slug).then(setPage).catch(() => {}); }, [slug]);
  return (
    <>
      <Seo
        title={page?.meta_title || defaultTitle}
        description={page?.meta_description}
        robots={page?.meta_robots || "index,follow"}
        jsonLd={page?.schema_json}
      />
      <PageHero
        eyebrow="Legal"
        title={page?.title || defaultTitle}
        subtitle={defaultSubtitle}
        showCta={false}
      />
      <div data-testid={`legal-page-${slug}`}>
        <PageSections sections={page?.sections || []} />
      </div>
    </>
  );
}
